import React from 'react'
import {translate} from 'react-i18next'
import Helmet from 'react-helmet'
import Header from '../components/Header.js'

const names = [
  'Radcliffe Takashi Onishi',
  'Yokoishi Keisuke',
  'Taniguchi Kazuki'
]
const roles = [
  'CEO  Founder / Producer',
  'COO / Product Management',
  'CDO / Data Scientist',
  'Backend, Blockchain Engineer',
  'Frontend Engineer',
  'Political Scientist / Contents Management',
  'Content Editor'
]
const snses = [
  {
    twitter: 'takac_radcliffe',
    facebook: 'takac.radcliffe'
  },
  {},
  {},
  {},
  {
    github: 'e-jigsaw'
  },
  {},
  {}
]

const Person = ({name, index, t}) => {
  const sns = snses[index]
  const links = Object.keys(sns)
  return (
    <div className="person">
      <div className="person-wrapper">
        <div className="person-profile">
          <div className="person-name-title">
            <div className="person-name">{name}</div>
            <div className="person-title">{roles[index]}</div>
          </div>
          <div className="person-message-container person-message-container__pc">
            <div className="person-message">
              <div>{t(`m${index}`)}</div>
              <div className="person-links">
                {links.map((key, index) => {
                  let link
                  switch (key) {
                    case 'twitter': {
                      link = <a href={`https://twitter.com/${sns.twitter}`}>tw</a>
                      break
                    }
                    case 'facebook': {
                      link = <a href={`https://fb.me/${sns.facebook}`}>fb</a>
                      break
                    }
                    case 'blog': {
                      link = <a href={sns.blog}>blog</a>
                      break
                    }
                    case 'github': {
                      link = <a href={`https://github.com/${sns.github}`}>github</a>
                      break
                    }
                  }
                  return links[index + 1] ? (
                    <span>
                      {link}
                      <span className="person-middot">&middot;</span>
                    </span>
                  ) : link
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="person-message-container person-message-container__sp">
        <div className="person-message">
          <div>{t(`m${index}`)}</div>
          <div className="person-links">
            <a href="#">tw</a>
            <span className="person-middot">&middot;</span>
            <a href="#">fb</a>
            <span className="person-middot">&middot;</span>
            <a href="#">blog</a>
            <span className="person-middot">&middot;</span>
            <a href="#">github</a>
          </div>
        </div>
      </div>
    </div>
  )
}

const Member = translate('member')(
  ({t}) => (
    <div id="member">
      <Header current="member" />
      <div className="container">
        <div className="col1 col-pad1">
          <h1 className="page-title">Member</h1>
        </div>
        <div className="col3 member-list">
          {
            names.map((name, index) => <Person key={index} name={name} index={index} t={t} />)
          }
        </div>
      </div>
    </div>
  )
)

export default () => (
  <div>
    <Helmet
      meta={[
        {name: 'description', content: 'Babels Members'},
        {property: 'og:title', content: 'Babels Members'},
        {property: 'og:url', content: 'https://babels.co/member'},
        {property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff'},
        {property: 'og:image:width', content: '600'},
        {property: 'og:image:height', content: '400'},
        {property: 'og:description', content: 'Babels Members'},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:site', content: '@null'},
        {name: 'twitter:creator', content: '@null'}
      ]}
    />
    <Member />
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/member.js